// extracted by mini-css-extract-plugin
export var content = "_v8-1";
export var wrapper = "_v8-0";